import { PageProps } from '@wix/design-system';
import React, { ReactNode } from 'react';
import { CairoEntityPageContextProvider } from '../../providers';
import { CairoEntityPageState } from '../../state';
import { FormPage } from '../FormPage';

interface PagePropsWithChildren extends PageProps {
  state: CairoEntityPageState;
}

export interface CairoEntityPageProps extends PagePropsWithChildren {
  children: ReactNode;
}

export function CairoEntityPage({
  children,
  state,
  ...rest
}: CairoEntityPageProps) {
  return (
    <CairoEntityPageContextProvider value={state}>
      <FormPage state={state.formPage} {...rest}>
        {children}
      </FormPage>
    </CairoEntityPageContextProvider>
  );
}
